export const JAVA_SERVER_API_URL_DEV =
  "https://java-server-dev-860244534025.asia-northeast3.run.app";
export const JAVA_SERVER_API_URL_PROD =
  "https://java-server-200439388024.asia-northeast3.run.app";
export const JAVA_GCR_SERVER_API_URL_DEV =
  "https://java-server-dev-860244534025.asia-northeast3.run.app";
export const JAVA_GCR_SERVER_API_URL_PROD =
  "https://java-server-200439388024.asia-northeast3.run.app";
